module.exports = __webpack_public_path__ + "static/media/receipt.d692c3a5.svg";